// System-managed lookup values — Appeal Status & Parcel Status.
//
// These two lists are `system_managed` in lookup_lists: their option labels/codes are seeded to match
// the app logic and can't be edited in Table Management (a UI guard), so they never drift. App logic
// references the STABLE CODE (the object key here); the VALUE is the label that's actually stored on
// parcels.appeal_status / parcels.parcel_status and shown in dropdowns. Using these named constants
// (keyed by code) instead of bare string literals is behavior-identical — same stored values — but the
// logic now keys off the code, not a scattered label literal.
//
// Keep in sync with supabase/migrations/2026-06-30_parcel_lookups.sql (lists "Appeal Status"/"Parcel Status")
// AND with the CHECK on parcel_year_data.appeal_status (2026-08-17_appeal_status_year_grained.sql). Three
// places now agree; they did not before — 'withdrawn' existed here and was never seeded, and
// 'appeal_closed' was seeded and used by a rollup while meaning nothing to the business.
//
// ⛔ appeal_status is PER VALUE YEAR — parcel_year_data.appeal_status. parcels.appeal_status is RETIRED
// (kept, unwritten). A new year starts at Value Pending; the roll does not carry it forward.
// ⛔ 'Appeal Closed' REMOVED 2026-08-17 (zero live rows). Terminal states are Value Accepted (never
// appealed), Withdrawn (appealed, then pulled) and Denied (appealed, and the appeal was refused — Philip
// 2026-10-26; it took Appeal Closed's old place, sort 5).

export const APPEAL_STATUS = {
  value_pending:  'Value Pending',
  under_review:   'Under Review',
  value_accepted: 'Value Accepted',
  appeal_open:    'Appeal Open',
  withdrawn:      'Withdrawn',      // appeal was filed then pulled — original value stands (distinct from Value Accepted, where we never appealed)
  denied:         'Denied',         // appeal was decided against us — the value it appealed from stands, as for Withdrawn
};

// ⛔ THE OUTSTANDING SET, named once. Outstanding = an appeal that is live and unresolved.
//   'Value Accepted', 'Withdrawn' and 'Denied' are TERMINAL — the matter is closed either way.
//   'Value Pending' means NO NOTICE YET, so there is nothing to appeal — not outstanding.
//   NULL is NOT outstanding either: the year roll writes appeal_status null (roll_state_parcels,
//   `null::text -- appeal_status NOT carried`), so a rolled year with no notice would otherwise
//   masquerade as an open appeal. A report excluding nulls should SAY so when that is why it is
//   empty, rather than showing a blank page.
export const APPEAL_STATUS_OUTSTANDING = [APPEAL_STATUS.appeal_open, APPEAL_STATUS.under_review];

export const PARCEL_STATUS = {
  active:      'Active',
  prior_agent: 'Prior Agent',
  final_year:  'Final Year',
  retired:     'Retired',
};
